export default __webpack_public_path__ + "static/media/apigateway.a1c4c352.png";